import { render, staticRenderFns } from "./PagamentoDocumentoExcluir.vue?vue&type=template&id=7c65a15a"
import script from "./PagamentoDocumentoExcluir.vue?vue&type=script&lang=js"
export * from "./PagamentoDocumentoExcluir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports